import { render, staticRenderFns } from "./RoomDetails.vue?vue&type=template&id=5a9dd0ff&lang=pug&"
import script from "./RoomDetails.vue?vue&type=script&lang=ts&"
export * from "./RoomDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports